import { FormGroup, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/system';

export const StyledHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: 700,
}));

export const StyledMessageContainer = styled(Grid)({
  marginTop: '1.5rem',
});

export const StyledMessage = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  marginTop: '1.5rem',
  marginRight: '1rem',
  display: 'inline-block',
}));

export const StyledFormGroup = styled(FormGroup)({
  paddingBottom: '1.5rem',
});
